class ActualizarInformacionRequest {

    patchActualizarInformacion = (datosConsulta) => {
        return {
            "datos": {
                "celular"   : datosConsulta.celular,
                "correo"    : datosConsulta.correoEle,
                "consentimientoInformativo" : datosConsulta.terminos
            }
        }
    }

}

export default ActualizarInformacionRequest;